// extracted by mini-css-extract-plugin
export default {"summaryOperators":"utils_summaryOperators__mKO80","productDetailsSummary":"utils_productDetailsSummary__RH5q5","productDetailsSummaryValue":"utils_productDetailsSummaryValue__M1rlS"};